import axios from 'axios';

export default axios.create({
  baseURL: `https://${document.domain}/api`,
  withCredentials: true
})